import { useFinancialCatalogStore } from "@/core/store/financialCatalog/useFinancialCatalogStore";
import { handleFinancialCatalogError } from "@/core/store/financialCatalog/handleFinancialCatalogError";

export type IEmpresasOpt = {
  label: string;
  value: string;
  attributes?: Record<string, unknown> | null;
};

export default function handleEmpresasOpt() {
  const handle = async (): Promise<IEmpresasOpt[]> => {
    const companies = await useFinancialCatalogStore()
      .loadCompanies()
      .catch(handleFinancialCatalogError);

    return companies.map((company) => ({
      label: company.name,
      value: company.id,
      attributes: {
        Marca: company.brand ?? null
      }
    }));
  };

  return {
    handle
  };
}
